import React, { useState } from 'react';
import RangeSwarmStatic from './RangeSwarmStatic';
import RangeSwarmDynamic from './RangeSwarmDynamic';

export interface DataItem {
  id: string;
  value: number;
}

export interface RangeSwarmChartProps {
  dataArray: DataItem[];
  histMax: number;
  histMin: number;
  histNA: number;
  histLength: number;
  chartId: string;
  indicator: any;
  data: any;
  colorClass: string;
  labelOnly?: any;
  options?: any;
  context: string;
  preppedData?: any;
}

const RangeSwarm: React.FC<RangeSwarmChartProps> = ({ dataArray, histMax, histMin, histNA, histLength, chartId, indicator, data, colorClass, labelOnly = null, options = null, context, preppedData = null }) => {
  const [nodes, setNodes] = useState<DataItem[]>([]);

  return indicator ? (
    <div className="module-parent">
      <div className="module-child-2-chart">
        <RangeSwarmStatic
          key={`static_${indicator.variable}`}
          dataArray={dataArray}
          histMax={histMax}
          histMin={histMin}
          histNA={histNA}
          histLength={histLength}
          chartId={chartId}
          nodes={nodes}
          setNodes={setNodes}
          indicator={indicator.variable}
          colorClass={colorClass}
          DESCRIPTOR={data.meta["DESCRIPTOR"][indicator.variable]}
          labelOnly={labelOnly}
          allData={data}
          options={options}
          context={context}
          preppedData={preppedData}
        />
        <RangeSwarmDynamic
          key={`dynamic_${indicator.variable}`}
          dataArray={dataArray}
          histMax={histMax}
          histMin={histMin}
          histNA={histNA}
          histLength={histLength}
          chartId={chartId}
          nodes={nodes}
          DESCRIPTOR={data.meta["DESCRIPTOR"][indicator.variable]}
          labelOnly={labelOnly}
          data={data}
          context={context}
        />
      </div>
    </div>
  ) : null;
};

export default RangeSwarm;